import {useRef,useState} from 'react';
import {GraphyoActivity,flushGraphyoAnswers} from './GraphyoActivity';
import type {GraphyoProps} from './GraphyoEmbedded';
import {densityChanges,mergeDensityValues,type ClassDensityChange,type ClassDensityValues} from './graphyo-density';
export type SharedGraphyoHandlers={load:()=>Promise<ClassDensityValues>;publish:(cells:ClassDensityChange[])=>Promise<ClassDensityValues>};
export function SharedGraphyoActivity({shared,...props}:GraphyoProps&{shared?:SharedGraphyoHandlers}){
 const root=useRef<HTMLDivElement>(null),baseline=useRef<ClassDensityValues>({}),latest=useRef(props.value);
 latest.current=props.value;
 const [busy,setBusy]=useState(false),[notice,setNotice]=useState('');
 const readOnly=props.readOnly??props.disabled??false;
 const change=(value:string)=>{latest.current=value;props.onChange(value);};
 async function exchange(publish:boolean){
  if(!shared||busy)return;setBusy(true);setNotice('');
  try{
   await flushGraphyoAnswers(root.current);
   const changes=publish?densityChanges(latest.current,baseline.current):[];
   const values=publish&&changes.length?await shared.publish(changes):await shared.load();
   const preserved=publish?{}:Object.fromEntries(densityChanges(latest.current,baseline.current).map(c=>[String(c.concentration),c.value]));
   baseline.current=values;change(mergeDensityValues(latest.current,props.config,{...values,...preserved}));
   setNotice(Object.keys(values).length+' / 12 mesures réunies dans le tableau de la classe.'+(Object.keys(preserved).length?' Vos nouvelles mesures locales sont conservées ; partagez-les pour les ajouter.':''));
  }catch(e){setNotice((e as Error).message);}finally{setBusy(false);}
 }
 return <div ref={root}>
  {shared&&!readOnly&&<div role="group" aria-label="Mesures communes de la classe">
   <p>Saisir les deux masses volumiques de votre groupe, les partager, puis reprendre les mesures des autres groupes pour construire l’étalonnage.</p>
   <button type="button" disabled={props.disabled||busy} onClick={()=>void exchange(true)}>Partager mes mesures</button>{' '}
   <button type="button" disabled={props.disabled||busy} onClick={()=>void exchange(false)}>Reprendre le tableau de la classe</button>
   {notice&&<p role="status">{notice}</p>}
  </div>}
  <GraphyoActivity {...props} disabled={props.disabled||busy} readOnly={readOnly} onChange={change}/>
 </div>;
}
